import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";

@Injectable({
  providedIn: "root",
})
export class CreateAiAssistantService {
  hideOnboardingBackButton: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  prefilledAiData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  isDataLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {
    // Initialize with localStorage data if available
    this.loadPrefilledDataFromStorage();
  }

  loadPrefilledDataFromStorage() {
    const data = localStorage.getItem('prefilledAiData');
    if (data) {
      try {
        this.prefilledAiData.next(JSON.parse(data));
      } catch (e) {
        this.prefilledAiData.next(null);
      }
    } else {
      this.prefilledAiData.next(null);
    }
  }

  updatePrefilledData(data: any) {
    this.isDataLoading.next(true);
    
    if (data) {
      localStorage.setItem('prefilledAiData', JSON.stringify(data));
      this.prefilledAiData.next(data);
    } else {
      localStorage.removeItem('prefilledAiData');
      this.prefilledAiData.next(null);
    }
    
    // Set loading to false after a slight delay to allow components to update
    setTimeout(() => {
      this.isDataLoading.next(false);
    }, 100);
  }

  clearPrefilledData() {
    localStorage.removeItem('prefilledAiData');
    this.prefilledAiData.next(null);
    this.hideOnboardingBackButton.next(false);
  }
}
